import { useEffect, useState } from 'react';
import { useMainContext } from '../context';
import { ActionType } from '../context/types';
var useInitializeApp = function (config, accountId) {
    var _a = useState(false), appInitialized = _a[0], setAppInitialized = _a[1];
    var _b = useMainContext(), accountIdType = _b.accountIdType, dispatch = _b.dispatch;
    useEffect(function () {
        dispatch({
            type: ActionType.SET_CONTEXT,
            payload: {
                config: config,
                accountId: accountId,
                accountIdType: accountIdType
            }
        });
        setAppInitialized(!!accountId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config, accountId]);
    return {
        appInitialized: appInitialized
    };
};
export default useInitializeApp;
//# sourceMappingURL=use-initialize-app.js.map